import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function SicurezzaAcquistiPage() {
  return <ArticleLayout data={allArticles['sicurezza-acquisti']} />;
}